export default __webpack_public_path__ + "static/media/hofele.87f232f6.png";